/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FirmwareSortColumn } from '../../models/firmware-sort-column';
import { LocalDateTime } from '../../models/local-date-time';
import { PageDto } from '../../models/page-dto';
import { Sorting } from '../../models/sorting';

export interface GetAllFirmwares$Params {

/**
 * The index of requested page. The first page's index is 0
 */
  page?: number;

/**
 * The requested amount of pages. The amount of total pages depends on this value
 */
  pageSize?: number;
  releaseDate?: LocalDateTime;

/**
 * a user name pattern of the user who released the firmware
 */
  releasedBy?: string;

/**
 * The sort direction of the list
 */
  sort?: Sorting & any;

/**
 * Sort by field, default by ID
 */
  sortBy?: FirmwareSortColumn & any;

/**
 * a version pattern the firmware versions should look like
 */
  version?: string;
}

export function getAllFirmwares(http: HttpClient, rootUrl: string, params?: GetAllFirmwares$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
  const rb = new RequestBuilder(rootUrl, getAllFirmwares.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('releaseDate', params.releaseDate, {});
    rb.query('releasedBy', params.releasedBy, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('version', params.version, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto>;
    })
  );
}

getAllFirmwares.PATH = '/firmwares';
